import React, { useState } from 'react';
import classnames from 'classnames';
import SvgAF from 'components/shared/SvgAF/SvgAF';
import { IconLoader } from 'common/IconLoader';
import './CheckCard.css';

export const CheckCard = (props) => {
  let customStyle = { width: props.customWidth + 'px' };
  const [localSelected, setLocalSelected] = useState(false);

  let isSelected = props.isSelected == null ? localSelected : props.isSelected;

  return (
    <div>
      {!props.checkMode && (
        <div
          className={classnames({ autoHeight: props.autoHeight, CheckCard: true, CheckCard_Selected: isSelected })}
          style={customStyle}
          key={props.index && props.index}
        >
          <div className="CheckCard_Header">
            {props.title && <span className="CheckCard_Header_Title">{props.title}</span>}
          </div>
          <div className="CheckCard_Content">
            <p className="CheckCard_Content_Description" data-tip={props.description}>
              {props.description ? props.description : ''}
            </p>
          </div>
        </div>
      )}

      {props.checkMode && (
        <div
          className={classnames({ autoHeight: props.autoHeight, CheckCardEdit: true, CheckCard_Selected: isSelected })}
          style={customStyle}
          key={props.index && props.index}
          onClick={() => {
            props.onClick && props.onClick(props.index);
            props.isSelected == null && setLocalSelected(!localSelected);
          }}
        >
          <div className="CheckCard_Header">
            {props.title && <span className="CheckCard_Header_Title">{props.title}</span>}
            {props.checkMode && !props.altCheck && (
              <SvgAF
                img={isSelected ? IconLoader.icon_role_selected : IconLoader.icon_role_none_selected}
                hover={isSelected ? IconLoader.icon_role_selected : IconLoader.icon_role_select_hover}
              />
            )}
          </div>
          <div className="CheckCard_Content">
            <p className="CheckCard_Content_Description" data-tip={props.description}>
              {props.description ? props.description : ''}
            </p>
            {props.altCheck && (
              <SvgAF
                img={isSelected ? IconLoader.icon_role_selected : IconLoader.icon_role_none_selected}
                hover={isSelected ? IconLoader.icon_role_selected : IconLoader.icon_role_select_hover}
              />
            )}
          </div>
        </div>
      )}
    </div>
  );
};
